import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

import Locales from './locales'
import Users from './users'
import Customers from './customers'
import Settings from './settings'
import Projects from './projects'
import Reports from './reports'
import Suppliers from './suppliers';
import Items from './items';
import Manufacturers from './manufacturers'
import PriceTypes from './priceTypes'
import Locations from './locations'
import Countries from './countries'
import ItemTypes from './itemTypes'
import Serials from './serials'
import SerialStatuses from './serialStatuses'
import SerialEvents from './serialEvents'
import DocumentGroups from './documentGroups'
import ItemCategories from './itemCategories'
import Properties from './properties'
import Terms from './terms'
import Conditions from './conditions'
import DeliveryTypes from './deliveryTypes'

export default new Vuex.Store({
    modules: {
        Locales,
        Users,
        Customers,
        Suppliers,
        Items,
        Settings,
        Projects,
        Reports,
        Manufacturers,
        Countries,
        PriceTypes,
        Locations,
        ItemTypes,
        Serials,
        SerialStatuses,
        SerialEvents,
        DocumentGroups,
        ItemCategories,
        Properties,
        Terms,
        Conditions,
        DeliveryTypes,
    },

    state: {
        user: null,
        notification: null,
    },

    mutations: {
        setUser(state, user) {
            state.user = user
            Cookies.set('api_token', (user ? user.api_token : ''))
        },

        setNotification(state, notification) {
            state.notification = notification
        },
    },

    getters: {
        authed: state => state.user !== null,
        isAdmin: state => state.user !== null && state.user.role.toLowerCase() === 'admin',
        user: state => state.user,
        apiToken: state => {
            return state.user !== null ? state.user.api_token : ''
        },
        notification: state => state.notification,
    },

    actions: {
        setUser(context, user) {
            context.commit('setUser', user)
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters.apiToken
        },

        auth(context, token = Cookies.get('api_token')) {
            return new Promise((resolve, reject) => {
                if (!token) {
                    context.commit('setUser', null)
                    return resolve(false)
                }

                window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

                window.axios.get('/api/user')
                    .then(response => {
                        context.commit('setUser', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        context.commit('setUser', null)
                        reject()
                    })
            })
        },

        setNotification(context, notification) {
            if (notification.msg) {
                context.commit('setNotification', {
                    msg: notification.msg,
                    type: notification.type
                })

                setTimeout(() => {
                    context.commit('setNotification', null)
                }, 3000)
            } else {
                context.commit('setNotification', null)
            }
        },
        setSuccess(context, msg) {
            context.dispatch('setNotification', { msg, type: 'success' })
        },
        setError(context, msg) {
            context.dispatch('setNotification', { msg, type: 'error' })
        },
        setWarning(context, msg) {
            context.dispatch('setNotification', { msg, type: 'warning' })
        },
    },

    strict: debug,
})
